import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a13c5e3c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13c5e3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a13c5e3c')) {
      api.createRecord('a13c5e3c', component.options)
    } else {
      api.reload('a13c5e3c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a13c5e3c&scoped=true", function () {
      api.rerender('a13c5e3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimList/index.vue"
export default component.exports